import * as i0 from '@angular/core';
import { Injectable, Directive, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { DefaultUrlSerializer } from '@angular/router';
import moment from 'moment';
let WindowRef = /*#__PURE__*/(() => {
  class WindowRef {
    getNativeWindow() {
      return window;
    }
    static {
      this.ɵfac = function WindowRef_Factory(t) {
        return new (t || WindowRef)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WindowRef,
        factory: WindowRef.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return WindowRef;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ScreenSizeService = /*#__PURE__*/(() => {
  class ScreenSizeService {
    constructor(windowRef) {
      this.screenBreaks = [1200, 992, 768, 0];
      this.screenBreakNames = ['lg', 'md', 'sm', 'xs'];
      this.currentScreenBreak = '';
      let initialScreenWidth = windowRef.getNativeWindow().innerWidth;
      let initialScreenSize = this.getScreenSize(initialScreenWidth);
      this.screenBreakSubject = new BehaviorSubject(initialScreenSize);
    }
    setScreenSize(screenWidth) {
      let screenSize = this.getScreenSize(screenWidth);
      this.screenBreakSubject.next(screenSize);
    }
    screenSizeObservable() {
      return this.screenBreakSubject;
    }
    getScreenSize(screenWidth) {
      for (let i = 0; i < this.screenBreaks.length; i++) {
        if (screenWidth >= this.screenBreaks[i]) {
          if (this.screenBreakNames[i] !== this.currentScreenBreak) {
            this.currentScreenBreak = this.screenBreakNames[i];
            return this.currentScreenBreak;
          }
          break;
        }
      }
      return this.currentScreenBreak;
    }
    static {
      this.ɵfac = function ScreenSizeService_Factory(t) {
        return new (t || ScreenSizeService)(i0.ɵɵinject(WindowRef));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ScreenSizeService,
        factory: ScreenSizeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ScreenSizeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ScreenSizeDirective = /*#__PURE__*/(() => {
  class ScreenSizeDirective {
    constructor(screenSizeService) {
      this.screenSizeService = screenSizeService;
    }
    onResize() {
      this.screenSizeService.setScreenSize(innerWidth);
    }
    static {
      this.ɵfac = function ScreenSizeDirective_Factory(t) {
        return new (t || ScreenSizeDirective)(i0.ɵɵdirectiveInject(ScreenSizeService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ScreenSizeDirective,
        selectors: [["", "highfieldcommonScreenSizeDirective", ""]],
        hostBindings: function ScreenSizeDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function ScreenSizeDirective_resize_HostBindingHandler($event) {
              return ctx.onResize($event);
            }, false, i0.ɵɵresolveWindow);
          }
        }
      });
    }
  }
  return ScreenSizeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AngularHighfieldcommonModule = /*#__PURE__*/(() => {
  class AngularHighfieldcommonModule {
    static forRoot() {
      return {
        ngModule: AngularHighfieldcommonModule
      };
    }
    static {
      this.ɵfac = function AngularHighfieldcommonModule_Factory(t) {
        return new (t || AngularHighfieldcommonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AngularHighfieldcommonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, CommonModule, FormsModule]
      });
    }
  }
  return AngularHighfieldcommonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MessageSeverityEnum = /*#__PURE__*/function (MessageSeverityEnum) {
  MessageSeverityEnum[MessageSeverityEnum["success"] = 1] = "success";
  MessageSeverityEnum[MessageSeverityEnum["info"] = 2] = "info";
  MessageSeverityEnum[MessageSeverityEnum["warning"] = 3] = "warning";
  MessageSeverityEnum[MessageSeverityEnum["error"] = 4] = "error";
  return MessageSeverityEnum;
}(MessageSeverityEnum || {});
var MessageTypeEnum = /*#__PURE__*/function (MessageTypeEnum) {
  MessageTypeEnum[MessageTypeEnum["message"] = 1] = "message";
  MessageTypeEnum[MessageTypeEnum["alert"] = 2] = "alert";
  return MessageTypeEnum;
}(MessageTypeEnum || {});
class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url) {
    return super.parse(url.toLowerCase());
  }
}
class UpperCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url) {
    return super.parse(url.toUpperCase());
  }
}
let DateTimeService = /*#__PURE__*/(() => {
  class DateTimeService {
    constructor() {
      this.dateFormat = "DD/MM/YYYY";
      this.timeFormat = "HH:mm:ss";
    }
    getLocalDateTime() {
      let utc = this.getMomentUtc();
      return moment(utc).local().toDate();
    }
    getUtcDate() {
      return this.getMomentUtc().toDate();
    }
    getDateOnlyFromDateTime(date) {
      return moment(date).format(this.dateFormat).toString();
    }
    convertUtcToLocalString(utcDate, dateOnly = false) {
      return moment(utcDate).local().format(dateOnly ? this.dateFormat : `${this.dateFormat} ${this.timeFormat}`);
    }
    convertUtcToFormattedLocalString(utcDate, customDateFormat) {
      return moment(utcDate).local().format(`${customDateFormat}`);
    }
    getMomentUtc() {
      return moment.utc();
    }
    static {
      this.ɵfac = function DateTimeService_Factory(t) {
        return new (t || DateTimeService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DateTimeService,
        factory: DateTimeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DateTimeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MessageService = /*#__PURE__*/(() => {
  class MessageService {
    constructor() {
      this.messages = new BehaviorSubject([]);
    }
    messagesObservable() {
      return this.messages;
    }
    showMessages(messages) {
      this.clearMessages();
      this.messages.next(messages);
    }
    showMessage(message) {
      this.clearMessages();
      this.messages.next([message]);
    }
    clearMessages() {
      this.messages.next([]);
    }
    getServerity(alertType) {
      switch (alertType) {
        case MessageSeverityEnum.success:
          return "success";
        case MessageSeverityEnum.info:
          return "info";
        case MessageSeverityEnum.warning:
          return "warn";
        case MessageSeverityEnum.error:
          return "error";
        default:
          throw new Error("Alert type is not implemented.");
      }
    }
    static {
      this.ɵfac = function MessageService_Factory(t) {
        return new (t || MessageService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MessageService,
        factory: MessageService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MessageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of angular-highfieldcommon
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AngularHighfieldcommonModule, DateTimeService, LowerCaseUrlSerializer, MessageService, MessageSeverityEnum, MessageTypeEnum, ScreenSizeDirective, ScreenSizeService, UpperCaseUrlSerializer, WindowRef };
